export function buildAuthSignInUrl(
  authBaseUrl: string,
  query?: string | URLSearchParams,
): string {
  const authUrl = new URL(authBaseUrl);
  authUrl.pathname = '/sign-in';
  authUrl.search = '';
  authUrl.hash = '';

  if (typeof query === 'string') {
    authUrl.search = query.startsWith('?') ? query.slice(1) : query;
    return authUrl.toString();
  }

  if (query) {
    authUrl.search = query.toString();
  }

  return authUrl.toString();
}
